<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Property Colors'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      <tidy-button
        [text]="'Save Changes'"
        [action]="boundSave"
        class="primary" />
      @for (address of addresses; track address) {
        <tidy-card>
          <form [formGroup]="form">
            @if (!address?.address_name) {
              <tidy-row>
                <tidy-tag
                  [color]="form?.get(getIdString(address?.id))?.value || ''" />
                <tidy-text
                  [header]="address?.address1 + ' '"
                  [translate]="false" />
              </tidy-row>
              @if (address?.address2 !== null && address?.address2 !== '') {
                <tidy-row
                  >
                  <tidy-text [header]="address?.address2" />
                </tidy-row>
              }
            }
            @if (address?.address_name) {
              <tidy-row>
                <tidy-tag
                  [color]="form?.get(getIdString(address?.id))?.value || ''" />
                <tidy-text
                  [header]="address?.address_name"
                  [translate]="false" />
              </tidy-row>
            }
            <tidy-row>
              <tidy-color-picker
                [formControlName]="getIdString(address.id)"
                [form]="form.controls[getIdString(address.id)]"
                [errorMessage]="'Please enter a color in hex format (ex: #41cab7)'"
                [submitted]="submitted" />
            </tidy-row>
          </form>
        </tidy-card>
      }
      <tidy-button
        [text]="'Save Changes'"
        [action]="boundSave"
        class="primary" />
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
